import { useQuery, useMutation } from "@apollo/client/react";
import Box from "@mui/material/Box";
import { Fragment, useEffect, useMemo, useState } from "react";
import { useDialogs } from "../../../../hooks/useDialogs";
import toast from 'react-hot-toast';
import { EmptyState } from "../../../../components/EmptyState/EmptyState";
import DataGridGenerico from "../../../../components/dataGrid/DataGridGenerico";
import { TabProfesionalHeader } from "../components/TabProfesional/TabProfesionalHeader";
import { TabProfesionalViewEquipoDialog } from "../components/TabProfesional/TabProfesionalViewEquipoDialog";
import { TabProfesionalUpdateHonorariosDialog } from "../components/TabProfesional/TabProfesionalUpdateHonorariosDialog";
import { TabProfesionalAddProfessionalDialog } from "../components/TabProfesional/TabProfesionalAddProfessionalDialog";
import { generateColumnsDefaultConfiguration } from '../../../../components/dataGrid/columnHelpers';
import { CustomButton } from "../../../../components/customButton/CustomButton";
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import EditIcon from "@mui/icons-material/Edit";
import { PopoverModal } from '../../../../components/popoverModal/PopoverModal';
import { GET_ALL_TIPO_PROFESIONALES } from '../../../../data/graphQL/queries/PlanCuidado/getTipoProfesionales';
import { adaptTipoProfesionalArray } from '../../../../adapters/tipoProfesionalAdapter';
import DELETE_EVALUACION_PROFESIONAL from "../../../../data/graphQL/mutations/GestionAsistencial/deleteEvaluacionProfesional";
import ENVIAR_EMAIL_PROFESIONAL from "../../../../data/graphQL/mutations/GestionAsistencial/enviarMailProfesional";
import '../gestionAsistencialCreationContent.scss';
import adaptEvaluacionProfesionalGrillaArray, { ALL_EVALUACION_PROFESIONAL_GRILLA } from "../../../../data/graphQL/queries/GestionAsistencial/getEvaluacionProfesionalGrilla";
import { TabProfesionalUpdateFrecuenciaDialog } from "../components/TabProfesional/TabProfesionalUpdateFrecuenciaDialog";
import adaptEvaluacionProfesionalReemplazoGrillaArray, { ALL_EVALUACION_PROFESIONAL_REEMPLAZOS_GRILLA } from "../../../../data/graphQL/queries/GestionAsistencial/getEvaluacionProfesionalReemplazoGrilla";
import { TabProfesionalReemplazoUpdateFrecuenciaDialog } from "../components/TabProfesional/TabProfesionalReemplazoUpdateFrecuenciaDialog";
import { useNavigate } from "react-router-dom";
import { VALIDAR_VISITA_CERO } from "../../../../data/graphQL/queries/GestionAsistencial/validarVisitaCero";
import { GET_VISITA_CERO_ID } from "../../../../data/graphQL/queries/GestionAsistencial/getVisitaCeroId";
import { GET_VALIDAR_EQUIPO } from "../../../../data/graphQL/queries/GestionAsistencial/getValidarEquipo";

export const TabProfesional = ({
  evaluacionSelected,
  idDelegacion,
  allowedWrite,
  pacienteData,
  profesionalLogged,
  contratoInicialData,
  cambioDireccion
}) => {
  const navigate = useNavigate();
  const { dialogs, handleOpenDialog, handleCloseDialog } = useDialogs({
    viewEquipo: false,
    updateHonorarios: false,
    addProfessional: false,
    updateFrecuencia: false,
    updateFrecuenciaReemplazo: false
  });
  const [tipoProfesionales, setTipoProfesionales] = useState([]);
  const [evaluacionProfesional, setEvaluacionProfesional] = useState([]);
  const [evaluacionProfesionalReemplazo, setEvaluacionProfesionalReemplazo] = useState([]);
  const [evaluacionProfesionalFrecuencia, setEvaluacionProfesionalFrecuencia] = useState(0);
  const [showEquipo, setShowEquipo] = useState(false);

  const { data: validarVisitaCero, refetch: validarVisitaCeroRefetech } =
    useQuery(VALIDAR_VISITA_CERO, {
      fetchPolicy: "no-cache",
      variables: { idEvaluacion: evaluacionSelected.idEvaluacion }
    });

  const { data: validarEquipo, refetch: validarEquipoRefetch, error: errorValidarEquipo } =
    useQuery(GET_VALIDAR_EQUIPO, {
      fetchPolicy: "no-cache",
      variables: { idEvaluacion: evaluacionSelected.idEvaluacion }
    });

  useEffect(() => {
    if (!validarEquipo) return;
    setShowEquipo(validarEquipo.existeConfirmacionEquipo);
  }, [validarEquipo]);

  useEffect(() => {
    if (!errorValidarEquipo) return;
    console.error("Error al validar si existe Equipo");
  }, [errorValidarEquipo]);

  const { data: visitaCeroData, refetch: visitaCeroRefetech } =
    useQuery(GET_VISITA_CERO_ID, {
      fetchPolicy: "no-cache",
      variables: { idEvaluacion: evaluacionSelected.idEvaluacion }
    });

  const { data: dataEvaluacionProfesionalGrilla, loading: loadingEvaluacionProfesional, refetch } =
    useQuery(ALL_EVALUACION_PROFESIONAL_GRILLA, {
      fetchPolicy: "no-cache",
      variables: { idEvaluacion: evaluacionSelected.idEvaluacion }
    });

  useEffect(() => {
    if (!dataEvaluacionProfesionalGrilla) return;
    setEvaluacionProfesional(adaptEvaluacionProfesionalGrillaArray(dataEvaluacionProfesionalGrilla));
  }, [dataEvaluacionProfesionalGrilla]);

  const { data: dataEvaluacionProfesionalReempGrilla, loading: loadingEvaluacionProfesionalReemplazo, refetch: refetchReemplazos } =
    useQuery(ALL_EVALUACION_PROFESIONAL_REEMPLAZOS_GRILLA, {
      fetchPolicy: "no-cache",
      variables: { idEvaluacion: evaluacionSelected.idEvaluacion }
    });

  useEffect(() => {
    if (!dataEvaluacionProfesionalReempGrilla) return;
    setEvaluacionProfesionalReemplazo(adaptEvaluacionProfesionalReemplazoGrillaArray(dataEvaluacionProfesionalReempGrilla));
  }, [dataEvaluacionProfesionalReempGrilla]);

  const { data: dataTipoProfesionales } = useQuery(GET_ALL_TIPO_PROFESIONALES);

  useEffect(() => {
    if (!dataTipoProfesionales) return;
    setTipoProfesionales(adaptTipoProfesionalArray(dataTipoProfesionales));
  }, [dataTipoProfesionales]);

  const [deleteEvaluacionProfesional] = useMutation(DELETE_EVALUACION_PROFESIONAL, {
    onCompleted: (data) => {
      if (data.deleteEvaluacionProfesional.success) {
        toast.success(data.deleteEvaluacionProfesional.valorEsperado);
        refetch().then(({ data }) => {
          setEvaluacionProfesional(adaptEvaluacionProfesionalGrillaArray(data));
        });
        refetchReemplazos().then(({ data }) => {
          setEvaluacionProfesionalReemplazo(adaptEvaluacionProfesionalReemplazoGrillaArray(data));
        });
      } else {
        toast.error(data.deleteEvaluacionProfesional.valorEsperado);
      }
    }
  });

  const [EnviarEmailProfesional] = useMutation(ENVIAR_EMAIL_PROFESIONAL, {
    onCompleted: (data) => {
      if (data?.enviarEmailProfesional) {
        toast.success("Email enviado con éxito.");
      } else {
        toast.error("Error al enviar email.");
      }
    }
  });

  const refecthVisitaCero = () => {
    validarVisitaCeroRefetech();
    visitaCeroRefetech();
  };

  const refecthValidarEquipo = () => {
    validarEquipoRefetch();
  };

  const handleDeleteEvaluacionProfesional = (idEvaluacionProfesional) => {
    deleteEvaluacionProfesional({
      variables: { idEvaluacionProfesional }
    });
  };

  const handleEnviarEmail = (idEvaluacionProfesional) => {
    EnviarEmailProfesional({
      variables: { idEvaluacionProfesional }
    });
  };

  const handleEditarAsignacionEvaluacionProfesional = (row) => {
    setEvaluacionProfesionalFrecuencia({
      idEvaluacionProfesional: row.idEvaluacionProfesional,
      profesional: row.profesional,
      idFrecuenciaRequerida: row.idFrecuenciaRequerida,
      idFrecuenciaPlan: row.idFrecuenciaPlan,
      frecuenciaPlan: row.frecuenciaPlan,
      fechaDesde: row.fechaDesde,
      fechaHasta: row.fechaHasta,
      puedeEditar: row.puedeEditar
    });
    handleOpenDialog("updateFrecuencia");
  };

  const handleEditarAsignacionEvaluacionProfesionalReemplazo = (row) => {
    // consulto los datos del profesional original
    setEvaluacionProfesionalFrecuencia({
      data: row
    });
    handleOpenDialog("updateFrecuenciaReemplazo");
  };

  const initialColumns = [
    {
      headerName: '',
      field: 'accion',
      width: 20,
      renderCell: (cellProps) => {
        const { row } = cellProps;
        const esFiguraUrgencia = row.figuraProfesional?.toLowerCase()?.includes("urgencia");
        return (
          <>
            <PopoverModal>
              <div className='popover-modal-content'>
                <div onClick={() => !!allowedWrite && handleEnviarEmail(row.idEvaluacionProfesional)} aria-hidden='true'
                  className='item-option clickable-option'>
                  <EmailOutlinedIcon className='edit-icon' />
                  <span className='toggle-action'>Enviar Email</span>
                </div>
                {allowedWrite && row.puedeEditar == 1 && !esFiguraUrgencia &&
                  <div onClick={() => handleEditarAsignacionEvaluacionProfesional(row)} aria-hidden='true'
                    className='item-option clickable-option'>
                    <EditIcon className='edit-icon' />
                    <span className='toggle-action'>Editar asignación</span>
                  </div>
                }
                {allowedWrite && row.puedeEditar == 1 &&
                  <div onClick={() => !!allowedWrite && handleDeleteEvaluacionProfesional(row.idEvaluacionProfesional)} aria-hidden='true'
                    className='item-option clickable-option'>
                    <DeleteOutlinedIcon className='edit-icon' />
                    <span className='toggle-action'>Eliminar</span>
                  </div>
                }
              </div>
            </PopoverModal>
          </>);

      }
    },
    {
      headerName: 'T. Profesional',
      field: 'idTipoProfesional',
      flex: 140,
      minWidth: 140,
      valueGetter: (idTipoProfesional) => {
        return tipoProfesionales?.find((x) => x.id === idTipoProfesional)?.displayName;
      }
    },
    {
      headerName: 'Figura',
      field: 'figuraProfesional',
      flex: 120,
      minWidth: 120
    },
    {
      headerName: 'Frec. Plan',
      field: 'frecuenciaPlan',
      flex: 120,
      minWidth: 120
    },
    {
      headerName: 'Frec. Requerida',
      field: 'frecuenciaRequerida',
      flex: 120,
      minWidth: 120
    },
    {
      headerName: 'Profesional',
      field: 'profesional',
      flex: 190,
      minWidth: 190
    },
    {
      headerName: 'F. Desde',
      field: 'fechaDesde',
      type: 'date',
      width: 90
    },
    {
      headerName: 'F. Hasta',
      field: 'fechaHasta',
      type: 'date',
      width: 90
    },
    {
      headerName: 'H. Presencial',
      field: 'valor',
      width: 100,
      valueGetter: (valor) => {
        return '$' + parseFloat(valor || 0).toLocaleString('es-AR');
      }
    },
    {
      headerName: 'H. Virtual',
      field: 'virtual',
      width: 100,
      valueGetter: (virtual) => {
        return '$' + parseFloat(virtual || 0).toLocaleString('es-AR');
      }
    },
    {
      headerName: 'Tramo',
      field: 'viatico',
      width: 100,
      valueGetter: (viatico) => {
        return '$' + parseFloat(viatico || 0).toLocaleString('es-AR');
      }
    },
    {
      headerName: 'Cbio. Sonda',
      field: 'cambioSonda',
      width: 100,
      valueGetter: (cambioSonda) => {
        return '$' + parseFloat(cambioSonda || 0).toLocaleString('es-AR');
      }
    },
    {
      headerName: 'Capacitación',
      field: 'capacitacion',
      width: 100,
      valueGetter: (capacitacion) => {
        return '$' + parseFloat(capacitacion || 0).toLocaleString('es-AR');
      }
    },
    {
      headerName: 'Urgencia',
      field: 'emergencia',
      width: 100,
      valueGetter: (emergencia) => {
        return '$' + parseFloat(emergencia || 0).toLocaleString('es-AR');
      }
    },
    {
      headerName: 'Ext. Duración',
      field: 'extraduracion',
      width: 110,
      valueGetter: (extraduracion) => {
        return '$' + parseFloat(extraduracion || 0).toLocaleString('es-AR');
      }
    }];


  const initialColumnsReemplazo = [
    {
      headerName: '',
      field: 'accion',
      width: 20,
      renderCell: (cellProps) => {
        const { row } = cellProps;
        return (
          <>
            <PopoverModal>
              <div className='popover-modal-content'>
                <div onClick={() => !!allowedWrite && handleEnviarEmail(row.idEvaluacionProfesional)} aria-hidden='true'
                  className='item-option clickable-option'>
                  <EmailOutlinedIcon className='edit-icon' />
                  <span className='toggle-action'>Enviar Email</span>
                </div>
                {allowedWrite && row.puedeEditar == 1 &&
                  <div onClick={() => handleEditarAsignacionEvaluacionProfesionalReemplazo(row)} aria-hidden='true'
                    className='item-option clickable-option'>
                    <EditIcon className='edit-icon' />
                    <span className='toggle-action'>Editar asignación</span>
                  </div>
                }
                {allowedWrite && row.puedeEditar == 1 &&
                  <div onClick={() => !!allowedWrite && handleDeleteEvaluacionProfesional(row.idEvaluacionProfesional)} aria-hidden='true'
                    className='item-option clickable-option'>
                    <DeleteOutlinedIcon className='edit-icon' />
                    <span className='toggle-action'>Eliminar</span>
                  </div>
                }
              </div>
            </PopoverModal>
          </>);

      }
    },
    {
      headerName: 'T. Profesional',
      field: 'idTipoProfesional',
      flex: 140,
      minWidth: 140,
      valueGetter: (idTipoProfesional) => {
        return tipoProfesionales?.find((x) => x.id === idTipoProfesional)?.displayName;
      }
    },
    {
      headerName: 'Frec. Requerida',
      field: 'frecuenciaRequerida',
      flex: 120,
      minWidth: 120
    },
    {
      headerName: 'Profesional',
      field: 'profesional',
      flex: 190,
      minWidth: 190
    },
    {
      headerName: 'Profesional original',
      field: 'profesionalOriginal',
      flex: 190,
      minWidth: 190
    },
    {
      headerName: 'F. Desde',
      field: 'fechaDesde',
      type: 'date',
      width: 90
    },
    {
      headerName: 'F. Hasta',
      field: 'fechaHasta',
      type: 'date',
      width: 90
    },
    {
      headerName: 'H. Presencial',
      field: 'valor',
      width: 100,
      valueGetter: (valor) => {
        return '$' + parseFloat(valor || 0).toLocaleString('es-AR');
      }
    },
    {
      headerName: 'H. Virtual',
      field: 'virtual',
      width: 100,
      valueGetter: (virtual) => {
        return '$' + parseFloat(virtual || 0).toLocaleString('es-AR');
      }
    },
    {
      headerName: 'Tramo',
      field: 'viatico',
      width: 100,
      valueGetter: (viatico) => {
        return '$' + parseFloat(viatico || 0).toLocaleString('es-AR');
      }
    },
    {
      headerName: 'Cbio. Sonda',
      field: 'cambioSonda',
      width: 100,
      valueGetter: (cambioSonda) => {
        return '$' + parseFloat(cambioSonda || 0).toLocaleString('es-AR');
      }
    },
    {
      headerName: 'Capacitación',
      field: 'capacitacion',
      width: 100,
      valueGetter: (capacitacion) => {
        return '$' + parseFloat(capacitacion || 0).toLocaleString('es-AR');
      }
    },
    {
      headerName: 'Urgencia',
      field: 'emergencia',
      width: 100,
      valueGetter: (emergencia) => {
        return '$' + parseFloat(emergencia || 0).toLocaleString('es-AR');
      }
    },
    {
      headerName: 'Ext. Duración',
      field: 'extraduracion',
      width: 110,
      valueGetter: (extraduracion) => {
        return '$' + parseFloat(extraduracion || 0).toLocaleString('es-AR');
      }
    }];


  const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns, true), [allowedWrite, evaluacionProfesional, tipoProfesionales]);
  const columnsReemplazo = useMemo(() => generateColumnsDefaultConfiguration(initialColumnsReemplazo, true), [allowedWrite, evaluacionProfesionalReemplazo, tipoProfesionales]);

  useEffect(() => {
    refecthVisitaCero();
    refecthValidarEquipo();
  }, [evaluacionProfesional]);

  const areThereProfessionals = evaluacionProfesional?.length || [] > 0;
  const areThereProfessionalsReemplazo = evaluacionProfesionalReemplazo?.length > 0;

  const handleClickVisitaCero = () => {
    navigate('/misVisitas/nuevaVisita', {
      state: {
        isNew: !visitaCeroData?.visitaCero?.idVisita,
        idVisita: visitaCeroData?.visitaCero?.idVisita || 0,
        idPaciente: evaluacionSelected?.idPaciente,
        idProfesional: profesionalLogged?.idProfesional,
        idTipoProfesional: profesionalLogged?.idTipoProfesional,
        idFiguraProfesional: 1,
        idTipoModulo: evaluacionSelected.idTipoModulo,
        idEvaluacion: evaluacionSelected.idEvaluacion,
        programa: evaluacionSelected.modulo,
        nroDocumentoPaciente: pacienteData.nroDocumento,
        idFrecuencia: 0,
        visitasProgramadas: `-`,
        periodo: `-`,
        esVisitaCero: true,
        onlyView: (validarVisitaCero?.validarVisitaCero?.valorEsperado == 2)
      }
    });
  };

  return (
    <>
      {areThereProfessionals ?
        <Box>
          <TabProfesionalHeader
            idPaciente={evaluacionSelected?.idPaciente}
            idEvaluacion={evaluacionSelected?.idEvaluacion}
            handleClickVisitaCero={handleClickVisitaCero}
            showVisitaCero={validarVisitaCero?.validarVisitaCero?.valorEsperado}
            showEquipo={showEquipo}
            handleOpenDialog={handleOpenDialog}
            cambioDireccion={cambioDireccion}
            allowedWrite={allowedWrite} />

          <DataGridGenerico
            columns={columns}
            totalCount={evaluacionProfesional.length}
            rows={evaluacionProfesional}
            toolbar={false}
            loading={loadingEvaluacionProfesional} />

          {areThereProfessionalsReemplazo && <>
            <br />
            <h3>Reemplazos</h3>
            <DataGridGenerico
              columns={columnsReemplazo}
              totalCount={evaluacionProfesionalReemplazo.length}
              rows={evaluacionProfesionalReemplazo}
              toolbar={false}
              loading={loadingEvaluacionProfesionalReemplazo} />

          </>}
        </Box> :

        <Fragment>
          <EmptyState
            text={"No se ha agregado ningún profesional"}
            buttonText={"Agregar profesional"}
            disabled={!allowedWrite}
            onClick={() => !!allowedWrite && handleOpenDialog("addProfessional")}
          />
          <div className="empty-grid">
            <CustomButton
              label={showEquipo ? "Ver equipo" : "No hay equipo asignado"}
              variant="outlined"
              disabled={!showEquipo}
              onClick={() => handleOpenDialog("viewEquipo")}
            />
          </div>
        </Fragment>

      }

      {dialogs.viewEquipo &&
        <TabProfesionalViewEquipoDialog
          open={dialogs.viewEquipo}
          handleCloseDialog={() => handleCloseDialog("viewEquipo")}
          evaluacionSelected={evaluacionSelected} />

      }

      {dialogs.updateHonorarios &&
        <TabProfesionalUpdateHonorariosDialog
          open={dialogs.updateHonorarios}
          handleCloseDialog={() => handleCloseDialog("updateHonorarios")}
          refetchEvaluacionProfesional={refetch}
          refetchReemplazos={refetchReemplazos}
          setEvaluacionProfesional={setEvaluacionProfesional}
          evaluacionProfesionalIds={[...new Set([
            ...evaluacionProfesional.map(p => p.idEvaluacionProfesional),
            ...evaluacionProfesionalReemplazo.map(p => p.idEvaluacionProfesional)
          ])]}
          setEvaluacionProfesionalReemplazo={setEvaluacionProfesionalReemplazo} />

      }

      {dialogs.addProfessional &&
        <TabProfesionalAddProfessionalDialog
          open={dialogs.addProfessional}
          handleCloseDialog={() => handleCloseDialog("addProfessional")}
          evaluacionSelected={evaluacionSelected}
          idDelegacion={idDelegacion}
          refetchEvaluacionProfesional={refetch}
          refetchReemplazos={refetchReemplazos}
          setEvaluacionProfesional={setEvaluacionProfesional}
          evaluacionProfesionales={evaluacionProfesional}
          setEvaluacionProfesionalReemplazo={setEvaluacionProfesionalReemplazo}
        />
      }

      {dialogs.updateFrecuencia &&
        <TabProfesionalUpdateFrecuenciaDialog
          open={dialogs.updateFrecuencia}
          handleCloseDialog={() => handleCloseDialog("updateFrecuencia")}
          evaluacionSelected={evaluacionSelected}
          refetchEvaluacionProfesional={refetch}
          setEvaluacionProfesional={setEvaluacionProfesional}
          evaluacionProfesionalFrecuencia={evaluacionProfesionalFrecuencia} />

      }

      {dialogs.updateFrecuenciaReemplazo &&
        <TabProfesionalReemplazoUpdateFrecuenciaDialog
          open={dialogs.updateFrecuenciaReemplazo}
          handleCloseDialog={() => handleCloseDialog("updateFrecuenciaReemplazo")}
          evaluacionSelected={evaluacionSelected}
          refetchEvaluacionProfesionalReemplazo={refetchReemplazos}
          setEvaluacionProfesionalReemplazo={setEvaluacionProfesionalReemplazo}
          evaluacionProfesionalFrecuencia={evaluacionProfesionalFrecuencia} />

      }
    </>);

};